export const projects = [
  {
    name: 'API de gestion de ordenes',
    type: 'Backend service',
    summary:
      'Servicio REST orientado a dominios, validacion de contratos, pruebas automatizadas y documentacion OpenAPI.',
    highlights: ['Arquitectura por capas', 'Manejo centralizado de errores', 'Pruebas de integracion'],
  },
  {
    name: 'Pipeline CI/CD para frontend estatico',
    type: 'DevOps',
    summary:
      'Build reproducible con GitHub Actions, artefactos versionados y despliegue preparado para S3 + CloudFront.',
    highlights: ['Cache de dependencias', 'Build en cada pull request', 'Invalidacion de CDN'],
  },
  {
    name: 'Dashboard de salud de servicios',
    type: 'Observability',
    summary:
      'Vista operativa para revisar latencia, errores y disponibilidad de servicios criticos desde una sola pantalla.',
    highlights: ['KPIs tecnicos', 'Estados por servicio', 'Alertas accionables'],
  },
];
